// $(document).ready(function () {
//   var width= $(window).width();
//   console.log(width);
//   if(width<768){
//     $(document).scroll(function () {
//       //stick nav to top of page
//       var y = $(this).scrollTop();
//       var mbl_cart = $('.product-info .product_guarantee').offset().top;
// //         console.log(y,mbl_cart);
//       if (y > mbl_cart || y < 200) {
//         $('.sticky_cart.mbl_cart').show();
//       } else {
//         $('.sticky_cart.mbl_cart').hide();
//       }
//     });
//   }
// });
$(document).ready(function() {

    $('.feed_main').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true
    });
  
    $('.mob_offerSlider').flickity({
      "lazyLoad": 2,
      "imagesLoaded": true,
      "draggable": true,
      "wrapAround": true,
      "contain": true,
      "freeScroll": false,
      pageDots: false,
  });

});






$(document).ready(function() {
    $('a.shipping-modal').click(function(e) {
        e.preventDefault();
        $('.modal.shipping-modal').css('display', 'block');
        $('body').css('overflow-y', 'hidden'); //Prevent double scrollbar.
    });

    $('.close-modal,.modal-sandbox').click(function(e) {
        e.preventDefault();
        $('.modal.shipping-modal').css('display', 'none');
        $('body').css('overflow-y', 'auto'); //Prevent double scrollbar.
    });
    $('a.value-props-modal').click(function(e) {
        e.preventDefault();
        $('.modal.value-props-modal').css('display', 'block');
        $('body').css('overflow-y', 'hidden'); //Prevent double scrollbar.
    });

    $('.close-modal,.modal-sandbox').click(function(e) {
        e.preventDefault();
        $('.modal.value-props-modal').css('display', 'none');
        $('body').css('overflow-y', 'auto'); //Prevent double scrollbar.
    });

    $('a.guarantee-value-props-modal').click(function(e) {
        $('.modal.guarantee-value-props-modal').css('display', 'block');
        $('body').css('overflow-y', 'hidden'); //Prevent double scrollbar.
    });

    $('.close-modal,.modal-sandbox').click(function(e) {
        e.preventDefault();
        $('.modal.guarantee-value-props-modal').css('display', 'none');
        $('body').css('overflow-y', 'auto'); //Prevent double scrollbar.
    });

});


$(function() {
    //utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
    //utils.createAccordion('.footer_menu', 'h6', 'ul');
    //utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
    //utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
    
  	//utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
    //utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');
    
  	//utils.initializeTabs();
    //utils.resizeActionButtons();
    //faqAccordion.init();
    /*
  	$(window).on('resize', function() {
        utils.resizeActionButtons();
    });
  */
  
  /*
    $('body').on('click', '.footer_menu', function(e) {
        var $content = $(this).next('ul');
        $content.slideToggle();
        $(this).toggleClass('active');
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
    });
    
    */
  
    var oldFlickityCreate = window.Flickity.prototype._create;
    window.Flickity.prototype._create = function() {
        var that = this;
        if (this.element.addEventListener) {
            this.element.addEventListener('load', function() {
                that.onresize();
            }, true);
        }
        this._create = oldFlickityCreate;
        return oldFlickityCreate.apply(this, arguments);
    };
    objectFitImages();
    header.loadMegaMenu();
    header.init();
    searchAutocomplete.init();
    utils.pageBannerCheck();
    slideshow.init();
    testimonial.init();
    videoSection.init();
    gallery.init();
    featuredPromotions.init();
    featuredCollectionSection.init();
    collectionSidebarFilter.init();
    cart.init();
    mapFunction.init();
    //homeProducts.init();
    //InstaSlider.init();
    //ReviewSlider.init();
    PromoBar.init();
    //productPage.initializeQuantityBox();
    //productPage.init();
    //productPage.loadProductRecommendations();
    recentlyViewed.init();
    var resizeTimeout;
    window.addEventListener('resize', function(event) {
        if (!resizeTimeout) {
            resizeTimeout = setTimeout(function() {
                resizeTimeout = null;
                if ($(window).width() <= 798) {
                    cart.init();
                    header.unload();
                    header.init();
                }
            }, 66);
        }
    }, false);
  
  /*
    $.fancybox.defaults.animationEffect = 'fade';
    $.fancybox.defaults.transitionEffect = 'fade';
    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.infobar = false;
    $.fancybox.defaults.toolbar = false;
    $.fancybox.defaults.arrows = false;
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.smallBtn = true;
    $.fancybox.defaults.live = false;
    $.fancybox.defaults.zoom = false;
    $.fancybox.defaults.mobile.preventCaptionOverlap = false;
    $.fancybox.defaults.mobile.toolbar = true;
    $.fancybox.defaults.mobile.buttons = ['close'];
    $.fancybox.defaults.mobile.clickSlide = 'close';
    $.fancybox.defaults.mobile.clickContent = 'zoom';
    $.fancybox.defaults.afterLoad = function(instance, slide) {
        if (instance.current.type == 'image') {
            slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>")
        }
        if (instance.group.length > 1) {
            slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>' + svgArrowSizeLeft + '</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>' + svgArrowSizeRight + '</span></a>')
        }
    }
    */
    //$('.lightbox[rel="gallery"]').fancybox();
    var currentValue = $(".search_form input[name='q']").val()
    if ($(".search_form input[name='q']").length > 0) {
        $(".search_form input[name='q']").val(currentValue.replace('*', ''));
    }
    $('#sort-by').val($('#sort-by').data('default-sort'));
    $('body').on('change', '#tag_filter, #sort-by', function() {
        quickFilter.init();
    });
    $('li#tag_filter').on('click', function(e) {
        e.preventDefault();
        var remove = $('li#tag_filter').removeClass('selected');
        if (remove) {
            $(this).addClass('selected');
            quickFilter.init();
        }
    });
    $('body').on('change', '#blog_filter', function() {
        var url = $(this).val();
        window.location = url;
    });
    $('input, select, textarea').on('focus blur', function(event) {
        $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
    });
    $('body').on('change', '[data-option-filter] input', function() {
        quickFilter.init();
        $("html, body").animate({
            scrollTop: ($('#pagecontent').offset().top)
        }, 500);
    })
    $('body').on('click', '[data-reset-filters]', function() {
        collectionSidebarFilter.clearAllFilters();
    });
    $('body').on('click', '[data-clear-filter]', function() {
        var selectedOption = $(this).parents('.filter-active-tag');
        collectionSidebarFilter.clearSelectedFilter(selectedOption);
    });
    $('body').on('change', '.currencies', function(e) {
        $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
    });
    $('body').on('change', '.js-quick-shop select', function(e) {
        var currentVariant = $('.js-quick-shop select[name="id"]').val();
        if (currentVariant && globalQuickShopProduct) {
            quickShop.updateVariant(currentVariant);
        }
    });
    var touchStartPos = 0;
    $(document).bind("touchstart", function(e) {
        touchStartPos = $(window).scrollTop();
    }).bind("touchend", function(e) {
        var distance = touchStartPos - $(window).scrollTop();
        if (distance > 20 || distance < -20) {
            e.preventDefault;
        }
    });
    $('body').on('click', '.sidebar .parent-link--false', function(e) {
        e.preventDefault();
        $menu = $(this).parent('li');
        $menu.find('.menu-toggle').toggleClass('active');
        $menu.find('ul').slideToggle();
    });
    if (window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({
            scrollTop: $("#new-comment").offset().top - 140
        }, 'slow');
    }
    $('body').on('mouseenter', '.icon-search', function() {
        $('.search-terms').focus();
    });
    $('body').on('click', '.icon-search', function() {
        $('input.search-terms').focus();
    });
    $('body').on('click', '.search-submit', function() {
        $(this).parent().submit();
    });
    if ($(window).width() > 798) {
        $(".animate_right").waypoint(function() {
            $(this.element).addClass("animated fadeInRight");
        }, {
            offset: '70%'
        });
        $(".animate_left").waypoint(function() {
            $(this.element).addClass("animated fadeInLeft");
        }, {
            offset: '70%'
        });
        $(".animate_up").waypoint(function() {
            $(this.element).addClass("animated fadeInUp");
        }, {
            offset: '70%'
        });
        $(".animate_down").waypoint(function() {
            $(this.element).addClass("animated fadeInDown");
        }, {
            offset: '70%'
        });
    }
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
        pageDots: usePageDots,
        imagesLoaded: true,
        arrowShape: arrowSize,
        lazyLoad: 2
    });
    if ($(window).width() <= 798) {
        utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
    }
    $('body').on('click', '.menu-toggle', function(e) {
        var $content = $(this).next('ul');
        $content.slideToggle();
        $(this).toggleClass('active');
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
    });
    if ($(window).width() >= 959) {
        var modal_width = '870px';
        if ($(window).width() >= 1200 || $('html').hasClass('ie')) {
            modal_width = '1110px'
        }
    }
    var $contact_form = $('.newsletter .contact-form');
    $contact_form.each(function() {
        var $cf = $(this);
        $cf.on('submit', function(e) {
            if ($('input[name="challenge"]', $cf).val() !== "true") {
                $.ajax({
                    type: $cf.attr('method'),
                    url: $cf.attr('action'),
                    data: $cf.serialize(),
                    success: function(data) {
                        $cf.fadeOut("slow", function() {
                            $cf.prev('.message').html("Thank you for joining our mailing list!");
                        });
                    },
                    error: function(data) {
                        $('input[name="challenge"]', $cf).val('true');
                        $cf.submit();
                    }
                });
                e.preventDefault();
            }
        });
    });
    $('.maps').click(function() {
        $('.maps iframe').css("pointer-events", "auto");
    });
    enableInfiniteScroll();
    enableInfiniteSearchScroll();
    var enableSamples = Shopify.enableSamples;

    function freeSample(cart) {
        let freeSampleId = Shopify.freeSampleId;
        if (!cart.items.length || !enableSamples) return false
        const freeSampleInCart = cart.items.some(item => item.id == freeSampleId)
        if (cart.items.length == 1 && freeSampleInCart) {
            freeSampleRemove()
        }
        if (cart.items.length != 0 && !freeSampleInCart) {
            freeSampleAddToCart(freeSampleId)
        }

        function freeSampleAddToCart(id) {
            $.ajax({
                type: 'POST',
                async: false,
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                    id: id,
                    quantity: 1
                },
                success: function() {
                    if (Shopify.template == 'cart') {
                        window.location.href = '/cart'
                    }
                }
            });
        }

        function freeSampleRemove() {
            $.ajax({
                type: 'POST',
                async: false,
                url: '/cart/clear.js',
                dataType: 'json',
                success: function() {
                    if (Shopify.template == 'cart') {
                        window.location.href = '/cart'
                    }
                }
            });
        }
    }
    $.ajax({
        url: '/cart.js',
        async: false,
        dataType: "json",
        cache: false,
        success: function(cart) {
            freeSample(cart);
            calculateProgress(cart.total_price, 4000);
        }
    })
    $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function(data) {
          console.log("kumtvo1");
            refreshCart(data);
            calculateProgress(data.total_price, 4000);
        }
    })

    function ajaxSubmitCart(cart) {
        $cart = cart;
        $.ajax({
            url: '/cart/update.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: $cart.serialize(),
            success: function(data) {
                calculateProgress(data.total_price, 4000);
                freeSample(data)
            }
        });
    }

    function ajaxUpdateCart(lineID, quantity, parent) {
        $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            async: false,
            cache: false,
            type: 'post',
            data: {
                quantity: quantity,
                line: lineID
            },
            success: function(data) {
                calculateProgress(data.total_price, 4000);
                freeSample(data);
            }
        });
        $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(data) {
                calculateProgress(data.total_price, 4000);
              console.log("kumtvo2");
                refreshCart(data);
                var lineIDIndex = lineID - 1;
                if (typeof data.items[lineIDIndex] === "undefined") {
                    var updated_quantity = 0;
                } else {
                    var updated_quantity = data.items[lineIDIndex].quantity;
                }
                if (quantity > 0 && quantity != updated_quantity) {
                    if (updated_quantity == 1) {
                        items_left_text = "item left";
                    } else {
                        items_left_text = "items left";
                    }
                    $('.warning--quantity').remove();
                    var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
                    parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
                    parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
                } else if (parent.is('#cart_form')) {
                    $("#cart_form").submit();
                }
            }
        })
    }

    function refreshCart(cart) {
      console.log("meibeidl");
        $(".cart_count").empty();
        $cartBtn = $(".cart_count");
        var value = $cartBtn.text() || '0';
        var cart_items_html = "";
        var cart_discounts_html = "";
        var cart_action_html = "";
        var cart_savings_html = "";
        var $cart = $(".cart_content form");
        var discounted_price_total = 0;
        var total_savings = 0;
        $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
        if (cart.item_count == 0) {
            $('.drcart_count').hide();
            $('.drcart_count').html();
        } else {
            if (cart.item_count == 1) {
                $('.drcart_count').html('(' + cart.item_count + ' Item)');
            } else {
                $('.drcart_count').html('(' + cart.item_count + ' Items)');
            }
            $('.drcart_count').show();
        }
        if (cart.item_count == 0) {
            $('.js-empty-cart__message').removeClass('hidden');
            $('.js-cart_content__form').addClass('hidden');
        } else {
            $('.js-empty-cart__message').addClass('hidden');
            $('.js-cart_content__form').removeClass('hidden');
            $.each(cart.items, function(index, item) {
                var itemDiscounts = item.discounts;
                var discountMessage = "";
                for (i = 0; i < itemDiscounts.length; i++) {
                    var amount = Shopify.formatMoney(itemDiscounts[i].amount, $('body').data('money-format'));
                    var title = itemDiscounts[i].title;
                    discountMessage = '<p class="notification-discount meta"><strong>Discount:</strong> ' + title + ' (-<span class="money"> ' + amount + '</span>)</p>';
                }
                var line_id = index + 1;
                var samp;
                if (Shopify.enableSamples) {
                    samp = '';
                } else {
                    samp = 'disabled';
                }
                if (item.product_type.indexOf('freesample') != -1) {
                    cart_items_html += '<li class="cart_item clearfix sample ' + samp + '">'
                } else {
                    cart_items_html += '<li class="cart_item clearfix">';
                }
                if (item.image) {
                    cart_items_html += '<div class="cart_image">' + '<a href="' + item.url + '"><img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' + '</a></div>';
                }
                if (item.product_type.indexOf('freesample') != -1 && Shopify.freeSampleTitle && Shopify.enableSamples) {
                    cart_items_html += '<div class="cart_item__title sample-title"><div class="item_vars_info"><div class="item_title">' + Shopify.freeSampleTitle
                } else {
                    cart_items_html += '<span class="mcart_remove" onclick="removeItem(this)" data-line="' + parseInt(i + 1) + '"><img src="https://cdn.shopify.com/s/files/1/0198/4521/8366/files/remove-icon.svg?9704"/></span><div class="cart_item__title"><div class="item_vars_info"><div class="item_title">' + item.product_title
                }
                if (item.product_type.indexOf('freesample') == -1) {
                    if (item.properties) {
                        $.each(item.properties, function(title, value) {
                            if (value) {
                                cart_items_html += '<div class="line-item">' + value + '</div>';
                            }
                        });
                    }
                }
                if (item.price > item.final_price) {
                    cart_items_html += '</div>' + discountMessage + '</a>';
                } else {
                    cart_items_html += '</div>'
                }
                if (item.options_with_values) {
                    $.each(item.options_with_values, function(title, vars) {
                        if (vars) {
                            if (vars.value.indexOf('Default') == -1) {
                                cart_items_html += '<div class="line-item">' + vars.value + '</div>';
                            }
                        }
                    });
                    cart_items_html += '</div>';
                    cart_items_html += '<div class="CartItem_Bottom_info"><div class="left product-quantity-box">' + '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' + '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" data-product-id="' + item.product_id + '" value="' + item.quantity + '" data-line-id="' + line_id + '" />' + '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' + '</div>';
                    cart_items_html += ' <div class="product-price-box"><strong class="right price">';
                    $.ajax({
                        dataType: "json",
                        async: false,
                        cache: false,
                        url: "/products/" + item.handle + ".js",
                        success: function(data) {
                            var variant_id = item.variant_id;
                            var variant = $.grep(data.variants, function(v) {
                                return v.id == variant_id;
                            });
                            if (variant[0] && variant[0].compare_at_price > item.price) {
                                discounted_price_total += item.price * item.quantity;
                                total_savings += variant[0].compare_at_price * item.quantity;
                            }
                        }
                    });
                    if (item.price > item.final_price) {
                        var itemPrice = Shopify.formatMoney(item.final_price, $('body').data('money-format')) + '</span><span class="money was_price">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>';
                        cart_items_html += '<span class="money">' + itemPrice + '</strong></div></div></a></li>';
                    } else {
                        var itemPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
                        if (item.product_type.indexOf('freesample') != -1) {
                            cart_items_html += '<span class="money">' + itemPrice + '</span></strong></div></div></li>';
                        } else {
                            cart_items_html += '<span class="money">' + itemPrice + '</span></strong></div></div></a></li>';
                        }
                    }
                }
            });
            var cartDiscounts = cart.cart_level_discount_applications;
            var cartDiscountMessage = "";
            for (i = 0; i < cartDiscounts.length; i++) {
                var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
                var title = cartDiscounts[i].title;
                cartDiscountMessage = '<p class="mm-counter price">' + title + ' (-<span class="money"> ' + amount + '</span>)</p>';
            }
            if (cart.cart_level_discount_applications.length > 0) {
                cart_discounts_html += '<span class="right">' + cartDiscountMessage + '</span><span>Discount</span>'
            }
            cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' + '<span>Zwischensumme</span>';
            cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' + '<span>Your Savings</span>';
        }
        $('.js-cart_items').html(cart_items_html);
        $('.js-cart_discounts').html(cart_discounts_html);
        $('.js-cart_subtotal').html(cart_action_html);
        $('.js-cart_savings').html(cart_savings_html);
        convertCurrencies();
    }
    $('body').on("change", "#cart_form input.quantity", function() {
        ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
    });
    $('body').on("change", ".cart_content input.quantity", function() {
        var id = $(this).data('product-id');
        var qty = $(this).val();
        var uitems = readCookie('upsell_items');
        if (uitems == id) {
            if (qty == 0) {
                $('.AddonItem__Row').show();
                $('.cart_addon_outer').show();
            }
        }
        ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
    });
    /*
  $(document).on('click', '.ajax-submit', function(e) {
        e.preventDefault();
        var $addToCartForm = $(this).closest('form');
      	console.log($addToCartForm);
      console.log($addToCartForm.serialize());
        var $addToCartBtn = $addToCartForm.find('.add_to_cart');
        $('body').addClass('blocked-scroll')
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: $addToCartForm.serialize(),
            beforeSend: function() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span.text').text('Danke!');
                window.setTimeout(function() {
                    $addToCartBtn.find('span.text').text('BUY NOW');
                    $addToCartBtn.attr('disabled', false).removeClass('disabled');
                }, 4000);
            },
            success: function(itemData) {
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');
                window.setTimeout(function() {
                    $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                    $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                    $addToCartBtn.find('span').removeClass('zoomOut');
                }, 1000);
                $.ajax({
                    url: '/cart.js',
                    async: false,
                    dataType: "json",
                    cache: false,
                    success: function(cart) {
                        calculateProgress(cart.total_price, 4000);
                        freeSample(cart);
                    }
                })
                $.ajax({
                    url: '/cart.js',
                    dataType: "json",
                    cache: false,
                    success: function(cart) {
                        setTimeout(function() {
                            calculateProgress(cart.total_price, 4000);
                            refreshCart(cart);
                            if ($('body').hasClass('fancybox-active')) {
                                //$.fancybox.close();
                            }
                            if ($(window).width() <= 798) {
                                var $cart_container = $(this).parent();
                                if ($cart_container.hasClass('active_link')) {
                                    $('body').addClass('blocked-scroll');
                                } else {
                                    $('body').addClass('blocked-scroll');
                                }
                            }
                        }, 100);
                        setTimeout(function() {
                            $('.cart_container').addClass('active_link');
                            $('.cart_overlay').addClass('ov_active');
                        }, 100);
                    }
                });
            },
            error: function(XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                if (response) {
                    response = response.description;
                    $('.warning').remove();
                    var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                    $addToCartForm.after(warning);
                    $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                    $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
                }
            }
        });
        return false;
    });
    */
    //productPage.productSwatches();
});
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {
    switch (selectorIndex) {
        case 0:
            var key = 'root';
            var selector = $(parent + ' .single-option-selector:eq(0)');
            break;
        case 1:
            var key = $(parent + ' .single-option-selector:eq(0)').val();
            var selector = $(parent + ' .single-option-selector:eq(1)');
            break;
        case 2:
            var key = $(parent + ' .single-option-selector:eq(0)').val();
            key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
            var selector = $(parent + ' .single-option-selector:eq(2)');
    }
    var availableOptions = Shopify.optionsMap[key];
    $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
        if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
            $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
        } else {
            $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
        }
    });
};
Shopify.linkOptionSelectors = function(product, parent) {
    Shopify.optionsMap = {};
    for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
            Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
            Shopify.optionsMap['root'].push(variant.option1);
            Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
            if (product.options.length === 3) {
                var key = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option3);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
        }
    }
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    $(parent + " .single-option-selector:eq(0)").change(function() {
        Shopify.updateOptionsInSelector(1, parent);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
    $(parent + " .single-option-selector:eq(1)").change(function() {
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
};

function htmlEncode(value) {
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

function is_touch_device() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
};
var touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

function floatToString(t, e) {
    var o = t.toFixed(e).toString();
    return o.match(/^\.\d+/) ? "0" + o : o
}
if ("undefined" == typeof Shopify) var Shopify = {};
Shopify.each = function(t, e) {
    for (var o = 0; o < t.length; o++) e(t[o], o)
}, Shopify.map = function(t, e) {
    for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
    return o
}, Shopify.arrayIncludes = function(t, e) {
    for (var o = 0; o < t.length; o++)
        if (t[o] == e) return !0;
    return !1
}, Shopify.uniq = function(t) {
    for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e
}, Shopify.isDefined = function(t) {
    return "undefined" == typeof t ? !1 : !0
}, Shopify.getClass = function(t) {
    return Object.prototype.toString.call(t).slice(8, -1)
}, Shopify.extend = function(t, e) {
    function o() {}
    o.prototype = e.prototype, t.prototype = new o, t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype
}, Shopify.locationSearch = function() {
    return window.location.search
}, Shopify.locationHash = function() {
    return window.location.hash
}, Shopify.replaceState = function(t) {
    window.history.replaceState({}, document.title, t)
}, Shopify.urlParam = function(t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "))
}, Shopify.newState = function(t, e) {
    var o;
    return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e, o + Shopify.locationHash()
}, Shopify.setParam = function(t, e) {
    Shopify.replaceState(Shopify.newState(t, e))
}, Shopify.Product = function(t) {
    Shopify.isDefined(t) && this.update(t)
}, Shopify.Product.prototype.update = function(t) {
    for (property in t) this[property] = t[property]
}, Shopify.Product.prototype.optionNames = function() {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}, Shopify.Product.prototype.optionValues = function(t) {
    if (!Shopify.isDefined(this.variants)) return null;
    var e = Shopify.map(this.variants, function(e) {
        var o = "option" + (t + 1);
        return void 0 == e[o] ? null : e[o]
    });
    return null == e[0] ? null : Shopify.uniq(e)
}, Shopify.Product.prototype.getVariant = function(t) {
    var e = null;
    return t.length != this.options.length ? e : (Shopify.each(this.variants, function(o) {
        for (var i = !0, r = 0; r < t.length; r++) {
            var n = "option" + (r + 1);
            o[n] != t[r] && (i = !1)
        }
        return 1 == i ? void(e = o) : void 0
    }), e)
}, Shopify.Product.prototype.getVariantById = function(t) {
    for (var e = 0; e < this.variants.length; e++) {
        var o = this.variants[e];
        if (t == o.id) return o
    }
    return null
}, Shopify.money_format = "$", Shopify.formatMoney = function(t, e) {
    function o(t, e) {
        return "undefined" == typeof t ? e : t
    }

    function i(t, e, i, r) {
        if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
        t = (t / 100).toFixed(e);
        var n = t.split("."),
            a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
            s = n[1] ? r + n[1] : "";
        return a + s
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        a = e || this.money_format;
    switch (a.match(n)[1]) {
        case "amount":
            r = i(t, 2);
            break;
        case "amount_no_decimals":
            r = i(t, 0);
            break;
        case "amount_with_comma_separator":
            r = i(t, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            r = i(t, 2);
            break;
        case "amount_no_decimals_with_comma_separator":
            r = i(t, 0, ".", ",")
    }
    return a.replace(n, r)
}, Shopify.OptionSelectors = function(t, e) {
    return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function() {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0
}, Shopify.OptionSelectors.prototype.initDropdown = function() {
    var t = {
            initialLoad: !0
        },
        e = this.selectVariantFromDropdown(t);
    if (!e) {
        var o = this;
        setTimeout(function() {
            o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t)
        })
    }
}, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(t) {
    this.selectors[0].element.onchange(t)
}, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(t) {
    var e = this.selectVariantFromParams(t);
    e || this.selectVariantFromDropdown(t)
}, Shopify.OptionSelectors.prototype.replaceSelector = function(t) {
    var e = document.getElementById(t),
        o = e.parentNode;
    Shopify.each(this.buildSelectors(), function(t) {
        o.insertBefore(t, e)
    }), e.style.display = "none", this.variantIdField = e
}, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(t) {
    var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1;
    var o = e.value;
    return this.selectVariant(o, t)
}, Shopify.OptionSelectors.prototype.selectVariantFromParams = function(t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t)
}, Shopify.OptionSelectors.prototype.selectVariant = function(t, e) {
    var o = this.product.getVariantById(t);
    if (null == o) return !1;
    for (var i = 0; i < this.selectors.length; i++) {
        var r = this.selectors[i].element,
            n = r.getAttribute("data-option"),
            a = o[n];
        null != a && this.optionExistInSelect(r, a) && (r.value = a)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0
}, Shopify.OptionSelectors.prototype.optionExistInSelect = function(t, e) {
    for (var o = 0; o < t.options.length; o++)
        if (t.options[o].value == e) return !0
}, Shopify.OptionSelectors.prototype.insertSelectors = function(t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var o = document.getElementById(t);
    Shopify.each(this.buildSelectors(), function(t) {
        o.appendChild(t)
    })
}, Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var t = 0; t < this.product.optionNames().length; t++) {
        var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
        e.element.disabled = !1, this.selectors.push(e)
    }
    var o = this.selectorDivClass,
        i = this.product.optionNames(),
        r = Shopify.map(this.selectors, function(t) {
            var e = document.createElement("div");
            if (e.setAttribute("class", o), i.length > 1) {
                var r = document.createElement("label");
                r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r)
            }
            return e.appendChild(t.element), e
        });
    return r
}, Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
        var o = this.selectors[e].element.value;
        t.push(o)
    }
    return t
}, Shopify.OptionSelectors.prototype.updateSelectors = function(t, e) {
    var o = this.selectedValues(),
        i = this.product.getVariant(o);
    i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e)
}, Shopify.OptionSelectorsFromDOM = function(t, e) {
    var o = e.optionNames || [],
        i = e.priceFieldExists || !0,
        r = e.delimiter || "/",
        n = this.createProductFromSelector(t, o, i, r);
    e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
}, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(t, e, o, i) {
    if (!Shopify.isDefined(o)) var o = !0;
    if (!Shopify.isDefined(i)) var i = "/";
    var r = document.getElementById(t),
        n = r.childNodes,
        a = (r.parentNode, e.length),
        s = [];
    Shopify.each(n, function(t, r) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
            var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
            0 == e.length && (a = n.length - (o ? 1 : 0));
            var p = n.slice(0, a),
                l = o ? n[a] : "",
                c = (t.getAttribute("value"), {
                    available: t.disabled ? !1 : !0,
                    id: parseFloat(t.value),
                    price: l,
                    option1: p[0],
                    option2: p[1],
                    option3: p[2]
                });
            s.push(c)
        }
    });
    var p = {
        variants: s
    };
    if (0 == e.length) {
        p.options = [];
        for (var l = 0; a > l; l++) p.options[l] = "option " + (l + 1)
    } else p.options = e;
    return p
}, Shopify.SingleOptionSelector = function(t, e, o, i) {
    this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement("select");
    for (var r = 0; r < i.length; r++) {
        var n = document.createElement("option");
        n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function(o, i) {
        i = i || {}, t.updateSelectors(e, i)
    }, !0
}, Shopify.Image = {
    preload: function(t, e) {
        for (var o = 0; o < t.length; o++) {
            var i = t[o];
            this.loadImage(this.getSizedImageUrl(i, e))
        }
    },
    loadImage: function(t) {
        (new Image).src = t
    },
    switchImage: function(t, e, o) {
        if (t && e) {
            var i = this.imageSize(e.src),
                r = this.getSizedImageUrl(t.src, i);
            o ? o(r, t, e) : e.src = r
        }
    },
    imageSize: function(t) {
        var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != e ? e[1] : null
    },
    getSizedImageUrl: function(t, e) {
        if (null == e) return t;
        if ("master" == e) return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != o) {
            var i = t.split(o[0]),
                r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r)
        }
        return null
    },
    removeProtocol: function(t) {
        return t.replace(/http(s)?:/, "")
    }
}, Shopify.OptionSelectors.HistoryState = function(t) {
    this.browserSupports() && this.register(t)
}, Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
    window.addEventListener("popstate", function(e) {
        t.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
}, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, o) {
    this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id))
}, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
};
$(document).on('shopify:block:select', function(e) {
    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    if ($parentSection.hasClass('solutions-section')) {
        //homeProducts.init();
    }
  	/*
    if ($parentSection.hasClass('insta-section')) {
        InstaSlider.init();
    }
    */
    //if($parentSection.hasClass('reviews-section')){ReviewSlider.init();}
    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
        sliderBlock.select(blockId, $parentSection);
    }
  	/*
    if ($parentSection.hasClass('recommended-products-section')) {
        if ($('.block__recommended_products').length) {
            productPage.init();
            productPage.loadProductRecommendations();
        }
    }
    */
    if ($parentSection.hasClass('page-details-section')) {
        if ($('.map-section').length) {
            mapFunction.init();
        }
    }
    if ($parentSection.hasClass('cart-section')) {
        if ($('.block__featured_collection').length) {
            featuredCollectionSection.init();
        }
    }
    if ($parentSection.hasClass('product-template')) {
        if ($('#shopify-product-reviews').length >= 1) {
            SPR.$(document).ready(function() {
                return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
            })
        }
    }
    utils.resizeActionButtons();
});
$(document).on('shopify:block:deselect', function(e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    if ($parentSection.hasClass('solutions-section')) {
        //homeProducts.init();
    }
  /*
    if ($parentSection.hasClass('insta-section')) {
        InstaSlider.init();
    }
    */
    //if($parentSection.hasClass('reviews-section')){ReviewSlider.init();}
    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
        sliderBlock.deselect($parentSection)
    }
});
$(document).on('shopify:section:reorder', function(e) {
    utils.pageBannerCheck();
});
$(document).on('shopify:section:load', function(e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    utils.pageBannerCheck();
    if ($parentSection.hasClass('header-section')) {
        productSpace();
    }
    if ($parentSection.hasClass('image-gallery-section')) {
        gallery.init($parentSection);
    }
    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {
            social.twitter();
            var $target = $(this).find(".js-instafeed");
            instagram.loadContent({
                el: $target,
                clientID: $target.data('client-id'),
                limit: $target.data('count'),
                column: $target.data('column')
            });
        });
    }
    if ($parentSection.hasClass('faq-section')) {
        faqAccordion.init();
    }
    if ($parentSection.hasClass('cart-section')) {
        cart.init();
        if ($('.block__featured_collection').length) {
            featuredCollectionSection.init();
        }
    }
    if ($parentSection.hasClass('featured-promotions-section')) {
        featuredPromotions.init();
    }
    if ($parentSection.hasClass('slideshow-section')) {
        slideshow.init();
    }
    if ($parentSection.hasClass('search-section')) {
        searchAutocomplete.init();
    }
    if ($parentSection.hasClass('testimonial-section')) {
        testimonial.init();
    }
    if ($parentSection.hasClass('featured-products-section')) {
        //productPage.initializeQuantityBox();
        //productPage.productSwatches();
        //productPage.init();
        if ($('.shopify-product-reviews-badge').length) {
            SPR.$(document).ready(function() {
                return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
            })
        }
    }
    if ($parentSection.hasClass('map-section')) {
        mapFunction.init();
    }
    if ($parentSection.hasClass('featured-collection-section')) {
        featuredCollectionSection.init();
    }
    if ($parentSection.hasClass('video-section')) {
        videoSection.init();
    }
    if ($parentSection.hasClass('recently-viewed__section')) {
        recentlyViewed.init();
    }
    if ($parentSection.hasClass('product-template')) {
        //productPage.init();
        //productPage.loadProductRecommendations();
        //productPage.productSwatches();
        recentlyViewed.init();
        if ($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
            SPR.$(document).ready(function() {
                return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
            })
        }
    }
  
    if ($parentSection.hasClass('recommended-products-section')) {
        //productPage.init();
        //productPage.loadProductRecommendations();
    }
    if ($parentSection.hasClass('article-template-section')) {
        if (window.location.pathname.indexOf('/comments') != -1) {
            $('html,body').animate({
                scrollTop: $("#new-comment").offset().top - 140
            }, 'slow');
        }
    }
    if ($parentSection.hasClass('collection-template-section')) {
        collectionSidebarFilter.init();
    }
    if ($parentSection.hasClass('contact-section')) {
        mapFunction.init();
    }
    if ($parentSection.hasClass('search-template-section')) {
        searchAutocomplete.init();
        collectionSidebarFilter.init();
    }
    if ($parentSection.hasClass('header-section')) {
        header.init();
        header.loadMegaMenu();
    }
    if ($parentSection.hasClass('mega-menu-section')) {
        header.loadMegaMenu();
    }
    if ($parentSection.hasClass('page-details-section')) {
        featuredCollectionSection.init();
        videoSection.init();
        if ($('.block__image_gallery').length) {
            gallery.init();
        };
        recentlyViewed.init();
    }
    if ($parentSection.hasClass('product-details-section')) {
        featuredCollectionSection.init();
        videoSection.init();
        mapFunction.init();
        if ($('.block__image_gallery').length) {
            gallery.init();
        };
        recentlyViewed.init();
        //productPage.init();
        //productPage.loadProductRecommendations();
    }
    if ($parentSection.hasClass('solutions-section')) {
        //homeProducts.init();
    }
  /*
    if ($parentSection.hasClass('insta-section')) {
        InstaSlider.init();
    }
    */
  	/*
    if ($parentSection.hasClass('reviews-section')) {
        ReviewSlider.init();
    }
    */
});
$(document).on('shopify:section:unload', function(e) {
    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    if ($parentSection.hasClass('header-section')) {
        header.unload($target);
        header.unloadMegaMenu();
    }
    if ($parentSection.hasClass('slideshow-section')) {
        slideshow.unload($target);
    }
    if ($parentSection.hasClass('testimonial-section')) {
        testimonial.unload($target);
    }
    if ($parentSection.hasClass('video-section')) {
        videoSection.unload($target);
    }
    if ($parentSection.hasClass('search-section')) {
        searchAutocomplete.unload($target);
    }
    if ($parentSection.hasClass('product-template')) {
        //productPage.unload($target);
    }
    if ($parentSection.hasClass('mega-menu-section')) {
        header.unloadMegaMenu();
    }
    if ($parentSection.hasClass('page-details-section')) {
        videoSection.unload($target);
    }
    if ($parentSection.hasClass('product-details-section')) {
        videoSection.unload($target);
    }
    if ($parentSection.hasClass('solutions-section')) {
        //homeProducts.init();
    }
  /*
    if ($parentSection.hasClass('insta-section')) {
        InstaSlider.init();
    }
    */
  /*
    if ($parentSection.hasClass('reviews-section')) {
        ReviewSlider.init();
    }
    */
});
$(document).on('shopify:section:select', function(e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {
            social.twitter();
        });
    }
    if ($parentSection.hasClass('mega-menu-section')) {
        var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
        setTimeout(function() {
            $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
            $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
            header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
        }, 10);
    }
    if ($parentSection.hasClass('featured-collection-section')) {
        featuredCollectionSection.unload($parentSection);
        featuredCollectionSection.init();
    }
    if ($parentSection.hasClass('solutions-section')) {
        //homeProducts.init();
    }
  /*
    if ($parentSection.hasClass('insta-section')) {
        InstaSlider.init();
    }
    */
  /*
    if ($parentSection.hasClass('reviews-section')) {
        ReviewSlider.init();
    }
    */
    if ($parentSection.hasClass('header-section')) {
        PromoBar.init();
    }
    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});
$(document).on('shopify:section:deselect', function(e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    if ($parentSection.hasClass('mega-menu-section')) {
        var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
    if ($parentSection.hasClass('solutions-section')) {
        //homeProducts.init();
    }
  /*
    if ($parentSection.hasClass('insta-section')) {
        InstaSlider.init();
    }
    */
  /*
    if ($parentSection.hasClass('reviews-section')) {
        ReviewSlider.init();
    }
    */
    if ($parentSection.hasClass('header-section')) {
        PromoBar.init();
    }
});
$(document).ready(function() {
    addon_sort();
    $(document).on('click', '.addon_atc', function(e) {
        e.preventDefault();
        var frm = $(this).parents('.CartItem');
        var v_id = $(this).parents('.AddonItem__Row').find('[name="id"]').val();
        var v_qty = $(this).parents('.AddonItem__Row').find('[name="quantity"]').val();
        addon_add_to_cart(v_id, v_qty, frm);
    });
    $(document).on('click', '.addon_arrows .addon_next', function() {
        var indx = $('.AddonItem__Row.AddonItem__Row__Active').data('index');
        if (indx == 1) {
            $('.addon_arrows .addon_prev').removeClass('disable');
        }
        var vlength = 0;
        $('.AddonItem__Row__Outer').each(function() {
            vlength = $(this).find('.AddonItem__Row ').length;
        });
        if (indx == parseInt(vlength - 1)) {
            $(this).addClass('disable');
        }
        $('.AddonItem__Row[data-index=' + indx + ']').removeClass('AddonItem__Row__Active');
        $('.AddonItem__Row[data-index=' + parseInt(indx + 1) + ']').addClass('AddonItem__Row__Active');
    });
    $(document).on('click', '.addon_arrows .addon_prev', function() {
        var indx = $('.AddonItem__Row.AddonItem__Row__Active').data('index');
        if (indx == 2) {
            $(this).addClass('disable');
        }
        var vlength = 0;
        $('.AddonItem__Row__Outer').each(function() {
            vlength = $(this).find('.AddonItem__Row ').length;
        });
        if (indx <= parseInt(vlength)) {
            $('.addon_arrows .addon_next').removeClass('disable');
        }
        $('.AddonItem__Row[data-index=' + indx + ']').removeClass('AddonItem__Row__Active');
        $('.AddonItem__Row[data-index=' + parseInt(indx - 1) + ']').addClass('AddonItem__Row__Active');
    });
});

function addon_add_to_cart(var_id, var_qty, form) {
    var id = $(form).data('product-id');
    data = {
        "quantity": var_qty,
        "id": var_id
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            getCart();
        }
    });
}

function getCart() {
    $.ajax({
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(data) {
            calculateProgress(data.total_price, 4000);
            refreshCartNew(data);
        }
    });
}

function addon_sort() {
    if ($('.AddonItem__Row__Outer .AddonItem__Row').length > 0) {
        var random = $("div.AddonItem__Row__Outer").randomize("div.AddonItem__Row");
        var u_items = [];
        if (random) {
            $('.AddonItem__Row__Outer .AddonItem__Row').each(function(i) {
                var id = $(this).find('.CartItem').data('product-id');
                u_items.push(id);
            });
            var x = u_items.toString();
            createCookie('upsell_items', x);
        }
    }
}

function fetch_upsell_items() {
    var uitems = readCookie('upsell_items');
    console.log(uitems);
    if (uitems) {
        $('.AddonItem__Row__Outer .AddonItem__Row').each(function(i) {
            var pid = $(this).find('.CartItem').data('product-id');
            if (uitems.indexOf(pid) > -1) {} else {
                $(this).hide();
            }
        });
    }
}
$.fn.randomize = function(tree, childElem) {
    return this.each(function() {
        var $this = $(this);
        if (tree) $this = $(this).find(tree);
        var unsortedElems = $this.children(childElem);
        var elems = unsortedElems.clone();
        elems.sort(function() {
            return (Math.round(Math.random()) - 0.5);
        });
        for (var i = 0; i < elems.length; i++)
            unsortedElems.eq(i).replaceWith(elems[i]);
    });
};

function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else {
        var expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

function refreshCartNew(cart) {
  console.log("meibeidlnew");
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_discounts_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart = $(".cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;
    $('body').append('<div style="display: none;" class="temp_cart_data">' + cart + '</div>');
    var dt = $('.temp_cart_data').find('.cart_content').html();
    $(".cart_content").html(dt);
    fetch_upsell_items();
    $('.temp_cart_data').remove();
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    if (cart.item_count == 0) {
        $('.drcart_count').hide();
        $('.drcart_count').html();
    } else {
        if (cart.item_count == 1) {
            $('.drcart_count').html('(' + cart.item_count + ' Item)');
        } else {
            $('.drcart_count').html('(' + cart.item_count + ' Items)');
        }
        $('.drcart_count').show();
    }
    if (cart.item_count == 0) {
        $('.js-empty-cart__message').removeClass('hidden');
        $('.js-cart_content__form').addClass('hidden');
    } else {
        $('.js-empty-cart__message').addClass('hidden');
        $('.js-cart_content__form').removeClass('hidden');
        $.each(cart.items, function(index, item) {
            var itemDiscounts = item.discounts;
            var discountMessage = "";
            for (i = 0; i < itemDiscounts.length; i++) {
                var amount = Shopify.formatMoney(itemDiscounts[i].amount, $('body').data('money-format'));
                var title = itemDiscounts[i].title;
                discountMessage = '<p class="notification-discount meta"><strong>Discount:</strong> ' + title + ' (-<span class="money"> ' + amount + '</span>)</p>';
            }
            var line_id = index + 1;
            var samp;
            if (Shopify.enableSamples) {
                samp = '';
            } else {
                samp = 'disabled';
            }
            if (item.product_type.indexOf('freesample') != -1) {
                cart_items_html += '<li class="cart_item clearfix sample ' + samp + '" >'
            } else {
                cart_items_html += '<li class="cart_item clearfix">';
            }
            if (item.image) {
                cart_items_html += '<div class="cart_image">' + '<a href="' + item.url + '"><img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" /></a>' + '</div>';
            }
            if (item.product_type.indexOf('freesample') != -1 && Shopify.freeSampleTitle && Shopify.enableSamples) {
                cart_items_html += '<div class="cart_item__title sample-title"><div class="item_vars_info"><div class="item_title">' + Shopify.freeSampleTitle
            } else {
                cart_items_html += '<span class="mcart_remove" onclick="removeItem(this)" data-line="' + parseInt(i + 1) + '"><img src="https://cdn.shopify.com/s/files/1/0198/4521/8366/files/remove-icon.svg?9704"/></span><div class="cart_item__title"><div class="item_vars_info"><div class="item_title">' + item.product_title
            }
            if (item.product_type.indexOf('freesample') == -1) {
                if (item.properties) {
                    $.each(item.properties, function(title, value) {
                        if (value) {
                            cart_items_html += '<div class="line-item">' + value + '</div>';
                        }
                    });
                }
                if (item.price > item.final_price) {
                    cart_items_html += '</div>' + discountMessage + '</a>';
                } else {
                    cart_items_html += '</div>'
                }
                if (item.options_with_values) {
                    $.each(item.options_with_values, function(title, vars) {
                        if (vars) {
                            if (vars.value.indexOf('Default') == -1) {
                                cart_items_html += '<div class="line-item">' + vars.value + '</div>';
                            }
                        }
                    });
                }
                cart_items_html += '</div>';
                cart_items_html += '<div class="CartItem_Bottom_info"><div class="left product-quantity-box">' + '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' + '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" data-product-id="' + item.product_id + '" value="' + item.quantity + '" data-line-id="' + line_id + '" />' + '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' + '</div>';
                cart_items_html += ' <div class="product-price-box"><strong class="right price">';
                $.ajax({
                    dataType: "json",
                    async: false,
                    cache: false,
                    url: "/products/" + item.handle + ".js",
                    success: function(data) {
                        var variant_id = item.variant_id;
                        var variant = $.grep(data.variants, function(v) {
                            return v.id == variant_id;
                        });
                        if (variant[0] && variant[0].compare_at_price > item.price) {
                            discounted_price_total += item.price * item.quantity;
                            total_savings += variant[0].compare_at_price * item.quantity;
                        }
                    }
                });
                if (item.price > item.final_price) {
                    var itemPrice = Shopify.formatMoney(item.final_price, $('body').data('money-format')) + '</span><span class="money was_price">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>';
                    cart_items_html += '<span class="money">' + itemPrice + '</strong></div></div></a></li>';
                } else {
                    var itemPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
                    if (item.product_type.indexOf('freesample') != -1) {
                        cart_items_html += '<span class="money">' + itemPrice + '</span></strong></div></div></li>';
                    } else {
                        cart_items_html += '<span class="money">' + itemPrice + '</span></strong></div></div></a></li>';
                    }
                }
            }
        });
        var cartDiscounts = cart.cart_level_discount_applications;
        var cartDiscountMessage = "";
        for (i = 0; i < cartDiscounts.length; i++) {
            var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
            var title = cartDiscounts[i].title;
            cartDiscountMessage = '<p class="mm-counter price">' + title + ' (-<span class="money"> ' + amount + '</span>)</p>';
        }
        if (cart.cart_level_discount_applications.length > 0) {
            cart_discounts_html += '<span class="right">' + cartDiscountMessage + '</span><span>Discount</span>'
        }
        cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' + '<span>Order Subtotal</span>';
        if (total_savings > 0) {
            cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' + '<span>Your Savings</span>';
        } else {
            cart_savings_html = "";
        }
    }
    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_discounts').html(cart_discounts_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);
    convertCurrencies();
}

function removeItem(item) {
    var line = $(item).data('line');
    data = {
        quantity: 0,
        line: line
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function(data) {
            calculateProgress(data.total_price, 4000);
            getCart();
        }
    });
}

function calculateProgress(currentVal, targetVal) {
    var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
    var progressNum = document.querySelectorAll('.cart-shipping__num');
    var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
    var successMsg = document.querySelectorAll('.cart-shipping__success');
    var result = Math.round(100 * currentVal / targetVal);
    progressBar.forEach(function(el) {
        el.setAttribute('style', "width: ".concat(result, "%"));
    })
    var newProgressNum = (targetVal - currentVal) / 100;
    if (newProgressNum <= 0) {
        successMsg.forEach(function(el) {
            el.setAttribute('style', 'display: block;');
        });
        progressOuter.forEach(function(el) {
            el.setAttribute('style', 'display: none;');
        });
        progressNum.forEach(function(el) {
            el.textContent = newProgressNum;
        });
    } else {
        successMsg.forEach(function(el) {
            el.setAttribute('style', 'display: none;');
        });
        progressOuter.forEach(function(el) {
            el.setAttribute('style', 'display: block;');
        });
        progressNum.forEach(function(el) {
            el.textContent = newProgressNum;
        });
    }
};
$(document).ready(function() {
    $("#scroll_to").click(function() {
        $('html, body').animate({
            scrollTop: $("#scroll_sec").offset().top
        }, 800);
    });
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 20) {
            $("#shopify-section-header").addClass("Header_bg");
            $('.prp_gallery').addClass('fixed_mobile');
        } else {
            $("#shopify-section-header").removeClass("Header_bg");
            $('.prp_gallery').removeClass('fixed_mobile');
        }
    });
    jQuery('.swatch :radio').change(function() {
        var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
        var optionValue = jQuery(this).val();
        jQuery(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    });
    $('.read_how_btn').click(function(e) {
        e.preventDefault();
        $(this).hide();
        $('.read_how_content').toggle();
    });

 
  
  
  	
  /*
    $('.mob_offerSlider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 2
            }
        }]
    });
    */
});

 window.SLIDECART_ADD_TO_CART = function({ id, quantity }) {
  const variant = meta.product.variants.find(v => v.id == id)
  if (!variant) return
  fbq('track', 'AddToCart', {
    content_name: variant.name, 
    content_ids: [variant.id],
    content_type: 'product',
    value: variant.price / 100,
    currency: 'EUR',
    num_items: quantity
  });  
}
  